(function () {
  'use strict';

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var allowed = privacy && privacy.value && privacy.value.allowedProcessing;
      return !allowed || allowed.analytics !== false;
    } catch (error) {
      return true;
    }
  }

  function publish(eventName, data) {
    if (!analyticsAllowed()) return;
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

    try {
      var result = window.Shopify.analytics.publish(eventName, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {
      // Measurement must never interrupt shopping or navigation.
    }
  }

  function cleanLabel(element) {
    return String(element.getAttribute('aria-label') || element.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 120);
  }

  function destination(element) {
    try {
      var url = new URL(element.href, window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return '';
    }
  }

  function surfaceFor(link) {
    if (link.closest('.ima')) return 'announcement';
    if (link.closest('.imh__actions')) return link.classList.contains('imh__button--primary') ? 'hero_primary' : 'hero_secondary';
    if (link.closest('.imh__seasonal')) return 'hero_browse';
    if (link.closest('.imh-card')) return 'hero_product';
    if (link.closest('.imd')) return 'ordering_path_explainer';
    if (link.closest('.imhp-moment')) return 'occasion_card';
    if (link.closest('.imhp__quick-links')) return 'collection_shortcut';
    if (link.closest('.imhp__section-links')) return 'featured_collection_link';
    if (link.closest('.imhp__product-grid')) return 'featured_product';
    if (link.closest('.imhp__service-grid')) return 'service_card';
    if (link.closest('.imhp__pro')) return 'pro_path';
    if (link.closest('.imfc-card')) return 'focused_collection';
    if (link.closest('.imr')) return 'demand_request';
    if (link.closest('.imcg')) return 'christmas_guide';
    if (link.closest('.imhdr__nav')) return 'desktop_navigation';
    if (link.closest('.imhdr__actions')) return 'header_action';
    if (link.closest('.imhdr__drawer')) return 'mobile_navigation';
    if (link.closest('.im-footer-vf')) return 'footer_navigation';
    return 'homepage_link';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ima a, .imh a, .imd a, .imhp a, .imfc a, .imr a, .imcg a, .imhdr a, .im-footer-vf a');
    if (!link || !link.href) return;

    var card = link.closest('[data-product-family]');
    var path = destination(link);
    var productPath = '';
    var collectionPath = '';
    if (path.indexOf('/products/') === 0) productPath = path.split('?')[0].replace('/products/', '');
    if (path.indexOf('/collections/') === 0) collectionPath = path.split('?')[0].replace('/collections/', '');

    publish('inkmerge:home_link_click', {
      surface: surfaceFor(link),
      label: cleanLabel(link),
      destination: path,
      productHandle: productPath,
      collectionHandle: collectionPath,
      productFamily: card ? (card.getAttribute('data-product-family') || '') : ''
    });
  }, { capture: true });

  document.addEventListener('submit', function (event) {
    var christmasForm = event.target.closest('#imhp-christmas-alert');
    if (christmasForm) {
      publish('inkmerge:christmas_alert_submit', {
        surface: 'homepage_christmas_alert',
        campaign: 'christmas-2026-interest'
      });
      return;
    }

    var requestForm = event.target.closest('#imr-next-drop-form');
    if (requestForm) {
      publish('inkmerge:next_drop_request_submit', {
        surface: 'homepage_demand_request'
      });
    }
  }, { capture: true });
})();
